import crown        from '../assets/crown-gold.svg';
import ChevronRight from './icons/ChevronRight.jsx';

const Footer = () => {

  const scrollToTop = () => { window.scrollTo({ top: 0, behavior: 'smooth' }) }

  return (
    <footer class="w-full bg-gradient-navigation">
      <div class="sm:h-[120px] md:h-[160px] lg:h-[160px] flex justify-center items-center">
        <img src={crown} alt="Rolex Crown" class="sm:w-[32px] sm:h-[32px] md:w-[40px] md:h-[40px] lg:w-[40px] lg:h-[40px] mx-auto"/>
      </div>
      <div class="sm:h-[60px] md:h-[80px] lg:h-[80px] border-t-[1px] border-white/40 flex justify-center items-center text-white">
        <button onClick={scrollToTop} class="group flex flex-col content-center items-center hover:text-oceanGreen">
          <ChevronRight height="15px" width="15px" class="-rotate-90 fill-white group-hover:fill-oceanGreen"/>
          Nach oben
        </button>
      </div>
    </footer>
  )
};

export default Footer;
